const translations = {
  en: {
    common: {
      loading: 'Loading...',
      loadingCalendar: 'Loading calendar...',
      logout: 'Logout',
      login: 'Login',
      register: 'Register',
      profile: 'Profile',
      calendar: 'Calendar',
      sessions: 'Sessions',
      bookSessions: 'Book Sessions',
      dashboard: 'Dashboard',
      availability: 'Availability',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      fullName: 'Full Name',
      coach: 'Coach',
      student: 'Student',
      goToDate: 'Go to Date',
      viewMode: 'View Mode',
      filterOptions: 'Filter Options',
      allCoaches: 'All Coaches',
      available: 'Available',
      full: 'Full',
      refresh: 'Refresh',
      tryAgain: 'Try again later',
      or: 'or',
      google: 'Continue with Google',
      googleSignup: 'Sign up with Google',
      googleLogin: 'Continue with Google',
      languageEnglish: 'English',
      languageChinese: '中文',
      switchToEnglish: 'Switch to English',
      switchToChinese: '切换到中文'
    },
    navbar: {
      toggleMenuOpen: 'Open navigation menu',
      toggleMenuClose: 'Close navigation menu'
    },
    auth: {
      loginTitle: 'Login',
      loginSuccess: 'Login successful!',
      loginButton: 'Login',
      loginLoading: 'Logging in...',
      registerPrompt: "Don't have an account?",
      registerLink: 'Register here',
      registerTitle: 'Register',
      registerButton: 'Register',
      registerLoading: 'Creating account...',
      registerSuccess: 'Registration successful!',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters long',
      roleLabel: 'I am a',
      hasAccountPrompt: 'Already have an account?',
      loginLink: 'Login here'
    },
    dashboard: {
      welcome: 'Welcome to your Dashboard, {{name}}!',
      accountCredits: 'Account Credits',
      loadingCredits: 'Loading credits...',
      failedCredits: 'Failed to load credits',
      accountBalance: 'Account Balance',
      coachFeatures: 'Coach Features',
      coachDescription: 'As a coach, you can:',
      coachFeatureList: [
        'Create and manage your available sessions',
        'View your calendar and bookings',
        'Set session prices and capacity',
        'Track your student bookings'
      ],
      manageSessions: 'Manage My Sessions',
      quickStats: 'Quick Stats',
      quickStatsDescription: 'Your coaching dashboard will show:',
      quickStatsList: [
        'Total sessions created',
        'Upcoming bookings',
        'Revenue summary',
        'Student feedback'
      ],
      viewProfile: 'View Profile',
      studentFeatures: 'Student Features',
      studentDescription: 'As a student, you can:',
      studentFeatureList: [
        'Browse available coaching sessions',
        'Book sessions with your favorite coaches',
        'View your upcoming sessions',
        'Cancel bookings if needed'
      ],
      browseSessions: 'Browse Sessions',
      myBookings: 'My Bookings',
      myBookingsDescription: 'Track your learning journey:',
      myBookingsList: [
        'View all your booked sessions',
        'See session details and coach info',
        'Manage your schedule',
        'Rate your experiences'
      ]
    },
    availability: {
      title: 'Coach Availability Calendar',
      coachLabel: 'Coach',
      monthLabel: 'Month',
      weekLabel: 'Week',
      dayLabel: 'Day',
      listLabel: 'List',
      monthRestricted: '(Desktop/Landscape Only)',
      studentsLabel: 'students',
      noSessions: 'No sessions available',
      noSessionsSub: 'No sessions scheduled',
      noSessionsDay: 'No sessions available for this day',
      sessionCoach: 'Coach:',
      sessionTime: 'Time:',
      sessionCapacity: 'Capacity:',
      sessionDescription: 'Description:',
      sessionStatusFull: 'FULL',
      sessionStatusAvailable: 'Available',
      sessionStatusPartial: '{{booked}}/{{capacity}}',
      calendarMonth: '{{month}}',
      calendarWeek: 'Week of {{weekRange}}',
      fetchSessionsError: 'Failed to fetch sessions',
      fetchDataError: 'Failed to load data'
    },
    subscriptions: {
      title: 'Coach Subscriptions',
      description: 'Get email alerts when your followed coaches add new sessions.',
      noSubscriptions: "You're not following any coaches yet.",
      noSubscriptionsHint: 'Follow coaches to receive email notifications when they add new sessions!',
      browseCoaches: 'Browse Coaches',
      followingSince: 'Following since',
      unsubscribe: 'Unsubscribe',
      follow: 'Follow',
      following: 'Following',
      followTooltip: 'Get email alerts when this coach adds new sessions',
      followingTooltip: "You're following this coach",
      subscribeSuccess: "You're now following {{coachName}}! You'll receive email alerts when they add new sessions.",
      unsubscribeSuccess: 'Unsubscribed from {{coachName}}',
      subscribeError: 'Failed to subscribe',
      unsubscribeError: 'Failed to unsubscribe',
      loadingSubscriptions: 'Loading subscriptions...'
    },
    sessions: {
        mySessions: 'My Sessions',
        createNewSession: 'Create New Session',
        cancel: 'Cancel',
        visibility: 'Who Can See This Session?',
        visibilityPublic: 'Public - Everyone can see',
        visibilityPublicDesc: 'All students can browse and book this session',
        visibilitySubscribers: 'Subscribers Only - Only followers can see',
        visibilitySubscribersDesc: 'Only students who follow you can see this session',
        visibilityWhitelist: 'Whitelist - Select specific students',
        visibilityWhitelistDesc: 'Only selected students can see this session',
        selectStudents: 'Select Students',
        selectedStudents: 'Selected Students',
        noStudentsSelected: 'No students selected',
        loadingStudents: 'Loading students...',
        searchStudents: 'Search students...',
      createSessionTitle: 'Create New Session',
      sessionTitle: 'Session Title',
      sessionTitlePlaceholder: 'e.g., Personal Training Session',
      maxStudents: 'Max Students',
      description: 'Description',
      descriptionPlaceholder: 'Describe what this session will cover...',
      date: 'Date',
      time: 'Time',
      selectTime: 'Select time',
      duration: 'Duration',
      duration15: '15 minutes',
      duration30: '30 minutes',
      duration45: '45 minutes',
      duration60: '60 minutes',
      duration90: '90 minutes',
      duration120: '120 minutes',
      repeat: 'Repeat',
      repeatNone: 'None',
      repeatDaily: 'Daily',
      repeatWeekly: 'Weekly',
      price: 'Price ($)',
      occurrences: 'Occurrences',
      occurrencesMax: 'Max 52 (one year)',
      createButton: 'Create Session',
      loadingSessions: 'Loading your sessions...',
      fetchSessionsError: 'Failed to fetch sessions',
      bookingApproved: 'Booking approved successfully',
      bookingRejected: 'Booking rejected successfully',
      approveError: 'Failed to approve booking',
      rejectError: 'Failed to reject booking',
      pendingBookings: 'Pending Bookings',
      student: 'Student:',
      pending: 'Pending',
      dateLabel: 'Date:',
      timeLabel: 'Time:',
      requested: 'Requested:',
      approve: 'Approve',
      reject: 'Reject',
      noSessionsYet: 'No sessions created yet',
      createFirstSession: 'Create your first session to start accepting bookings!',
      capacity: 'Capacity:',
      students: 'students',
      priceLabel: 'Price:',
      status: 'Status:',
      statusAvailable: 'available',
      edit: 'Edit',
      editComingSoon: 'Edit functionality coming soon!',
      delete: 'Delete',
      deleteConfirm: 'Delete this session? This cannot be undone.',
      sessionDeleted: 'Session deleted',
      deleteError: 'Failed to delete session',
      invalidStartTime: 'Please provide a valid start time',
      createdSkipped: 'Created {{created}} session(s), skipped {{skipped}} due to conflicts.',
      allConflicted: 'All occurrences conflicted with existing sessions. Nothing was created.',
      createdMultiple: 'Created {{count}} session(s).',
      createdSuccess: 'Session created successfully!',
      createError: 'Failed to create session'
    }
  },
  zh: {
    common: {
      loading: '加载中…',
      loadingCalendar: '日历加载中…',
      logout: '登出',
      login: '登录',
      register: '注册',
      profile: '个人资料',
      calendar: '日历',
      sessions: '课程',
      bookSessions: '预约课程',
      dashboard: '控制面板',
      availability: '空档',
      email: '电子邮箱',
      password: '密码',
      confirmPassword: '确认密码',
      fullName: '姓名',
      coach: '教练',
      student: '学员',
      goToDate: '跳至日期',
      viewMode: '查看模式',
      filterOptions: '筛选选项',
      allCoaches: '所有教练',
      available: '可预约',
      full: '已满',
      refresh: '刷新',
      tryAgain: '请稍后再试',
      or: '或',
      google: '使用 Google 继续',
      googleSignup: '使用 Google 注册',
      googleLogin: '使用 Google 登录',
      languageEnglish: 'English',
      languageChinese: '中文',
      switchToEnglish: '切换到英文',
      switchToChinese: '切换到中文'
    },
    navbar: {
      toggleMenuOpen: '打开导航菜单',
      toggleMenuClose: '关闭导航菜单'
    },
    auth: {
      loginTitle: '登录',
      loginSuccess: '登录成功！',
      loginButton: '登录',
      loginLoading: '正在登录…',
      registerPrompt: '还没有账户？',
      registerLink: '立即注册',
      registerTitle: '注册',
      registerButton: '注册',
      registerLoading: '正在创建账户…',
      registerSuccess: '注册成功！',
      passwordMismatch: '两次输入的密码不一致',
      passwordTooShort: '密码长度至少 6 个字符',
      roleLabel: '我是',
      hasAccountPrompt: '已经有账户？',
      loginLink: '立即登录'
    },
    dashboard: {
      welcome: '{{name}}，欢迎来到控制面板！',
      accountCredits: '账户余额',
      loadingCredits: '余额加载中…',
      failedCredits: '余额加载失败',
      accountBalance: '账户余额',
      coachFeatures: '教练功能',
      coachDescription: '作为教练，你可以：',
      coachFeatureList: [
        '创建并管理可预约的课程',
        '查看你的日历与预约情况',
        '设定课程价格与人数',
        '追踪学员预约'
      ],
      manageSessions: '管理我的课程',
      quickStats: '快捷统计',
      quickStatsDescription: '教练面板将显示：',
      quickStatsList: [
        '已创建课程总数',
        '即将开始的预约',
        '收入概览',
        '学员反馈'
      ],
      viewProfile: '查看个人资料',
      studentFeatures: '学员功能',
      studentDescription: '作为学员，你可以：',
      studentFeatureList: [
        '浏览可预约的教练课程',
        '预约心仪教练的课程',
        '查看即将开始的课程',
        '需要时取消预约'
      ],
      browseSessions: '浏览课程',
      myBookings: '我的预约',
      myBookingsDescription: '追踪你的学习旅程：',
      myBookingsList: [
        '查看所有已预约课程',
        '了解课程详情与教练信息',
        '管理你的时间安排',
        '为体验提供评分'
      ]
    },
    availability: {
      title: '教练空档日历',
      coachLabel: '教练',
      monthLabel: '月视图',
      weekLabel: '周视图',
      dayLabel: '日视图',
      listLabel: '列表视图',
      monthRestricted: '（仅限桌面/横屏）',
      studentsLabel: '名学员',
      noSessions: '暂无课程',
      noSessionsSub: '当前没有安排课程',
      noSessionsDay: '该日期暂无课程',
      sessionCoach: '教练：',
      sessionTime: '时间：',
      sessionCapacity: '人数：',
      sessionDescription: '简介：',
      sessionStatusFull: '已满',
      sessionStatusAvailable: '可预约',
      sessionStatusPartial: '{{booked}}/{{capacity}}',
      calendarMonth: '{{month}}',
      calendarWeek: '本周：{{weekRange}}',
      fetchSessionsError: '课程获取失败',
      fetchDataError: '数据加载失败'
    },
    subscriptions: {
      title: '教练订阅',
      description: '当你关注的教练添加新课程时，你会收到邮件提醒。',
      noSubscriptions: '你还没有关注任何教练。',
      noSubscriptionsHint: '关注教练，当他们添加新课程时你会收到邮件通知！',
      browseCoaches: '浏览教练',
      followingSince: '关注于',
      unsubscribe: '取消关注',
      follow: '关注',
      following: '已关注',
      followTooltip: '当此教练添加新课程时接收邮件提醒',
      followingTooltip: '你正在关注此教练',
      subscribeSuccess: '你已关注 {{coachName}}！当他们添加新课程时你会收到邮件提醒。',
      unsubscribeSuccess: '已取消关注 {{coachName}}',
      subscribeError: '关注失败',
      unsubscribeError: '取消关注失败',
      loadingSubscriptions: '订阅加载中…'
    },
    sessions: {
        mySessions: '我的课程',
        createNewSession: '创建新课程',
        cancel: '取消',
        visibility: '谁可以查看此课程？',
        visibilityPublic: '公开 - 所有人都可以查看',
        visibilityPublicDesc: '所有学员都可以浏览并预约此课程',
        visibilitySubscribers: '仅关注者 - 只有关注者可以查看',
        visibilitySubscribersDesc: '只有关注您的学员可以查看此课程',
        visibilityWhitelist: '白名单 - 选择特定学员',
        visibilityWhitelistDesc: '只有选中的学员可以查看此课程',
        selectStudents: '选择学员',
        selectedStudents: '已选学员',
        noStudentsSelected: '未选择学员',
        loadingStudents: '加载学员中...',
        searchStudents: '搜索学员...',
      createSessionTitle: '创建新课程',
      sessionTitle: '课程标题',
      sessionTitlePlaceholder: '例如：个人训练课程',
      maxStudents: '最大学员数',
      description: '描述',
      descriptionPlaceholder: '描述此课程将涵盖的内容...',
      date: '日期',
      time: '时间',
      selectTime: '选择时间',
      duration: '时长',
      duration15: '15 分钟',
      duration30: '30 分钟',
      duration45: '45 分钟',
      duration60: '60 分钟',
      duration90: '90 分钟',
      duration120: '120 分钟',
      repeat: '重复',
      repeatNone: '不重复',
      repeatDaily: '每天',
      repeatWeekly: '每周',
      price: '价格（美元）',
      occurrences: '重复次数',
      occurrencesMax: '最多 52 次（一年）',
      createButton: '创建课程',
      loadingSessions: '正在加载您的课程...',
      fetchSessionsError: '获取课程失败',
      bookingApproved: '预约已批准',
      bookingRejected: '预约已拒绝',
      approveError: '批准预约失败',
      rejectError: '拒绝预约失败',
      pendingBookings: '待处理预约',
      student: '学员：',
      pending: '待处理',
      dateLabel: '日期：',
      timeLabel: '时间：',
      requested: '请求时间：',
      approve: '批准',
      reject: '拒绝',
      noSessionsYet: '尚未创建课程',
      createFirstSession: '创建您的第一个课程以开始接受预约！',
      capacity: '容量：',
      students: '名学员',
      priceLabel: '价格：',
      status: '状态：',
      statusAvailable: '可预约',
      edit: '编辑',
      editComingSoon: '编辑功能即将推出！',
      delete: '删除',
      deleteConfirm: '删除此课程？此操作无法撤销。',
      sessionDeleted: '课程已删除',
      deleteError: '删除课程失败',
      invalidStartTime: '请提供有效的开始时间',
      createdSkipped: '已创建 {{created}} 个课程，跳过 {{skipped}} 个（因冲突）。',
      allConflicted: '所有重复课程与现有课程冲突。未创建任何课程。',
      createdMultiple: '已创建 {{count}} 个课程。',
      createdSuccess: '课程创建成功！',
      createError: '创建课程失败'
    }
  }
};

export default translations;

